import { Link } from "react-router-dom";
import MainLayout from "../../layout/MainLayout";
import { CallFillIcon, EnvelopeIcon } from "../../components/icons/icons";

function Homepage() {
  return (
    <MainLayout>
      <div className="md:h-full md:flex md:flex-col md:justify-center">
        <div className="md:mt-0 mt-20 md:flex md:justify-center md:items-center">
          <figure className="img-container w-64 md:me-8 md:ms-0 mx-auto rounded-full overflow-hidden ring-8 ring-gray-300/25">
            <img
              src="assets/images/md_salman_ezaz.jpeg"
              className="w-full"
              alt="md_salman_ezaz_image"
              title="Md. Salman Ezaz"
            />
          </figure>
          <div className="md:ms-0 md:mt-0 mt-20 text-center md:text-left">
            <h1 className="text-4xl font-bold">Md. Salman Ezaz</h1>
            <h3 className="mt-2">Web Developer • MERN Stack</h3>
          </div>
        </div>
        <div className="2xl:mt-36 md:mt-20 mt-10 flex justify-center flex-wrap">
          <Link
            to="tel:+8801632095012"
            title="Voice call to +8801632095012"
            className="flex items-center hover:text-blue-400 transition-all mx-4 my-2"
          >
            <div className="text-blue-600 w-7 h-7 rounded-full bg-gray-200 flex justify-center items-center">
              <CallFillIcon />
            </div>
            <span className="ms-3">01632-095012</span>
          </Link>
          <Link
            to="mailto:md.salmanezaz@gmail.com"
            title="Send email to md.salmanezaz@gmail.com"
            className="flex items-center hover:text-red-400 transition-all mx-4 my-2"
          >
            <div className="text-red-600 w-7 h-7 rounded-full bg-gray-200 flex justify-center items-center">
              <EnvelopeIcon />
            </div>
            <span className="ms-3">md.salmanezaz@gmail.com</span>
          </Link>
        </div>
      </div>
    </MainLayout>
  );
}

export default Homepage;
